import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FeatherIconComponent } from "../../../ui/feather-icon/feather-icon.component";
import { LayoutService } from '../../../../services/layout.service';
import { SettingsService } from '../../../../services/settings.service';

@Component({
  selector: 'app-header-logo',
  imports: [CommonModule, RouterModule, FeatherIconComponent],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent implements OnInit {

  @Input() icon: string;
  @Input() type: string;

  logoLight: string | null = null;
  logoDark: string | null = null;

  private readonly settingsService = inject(SettingsService);

  constructor(public layoutService: LayoutService) {}

  ngOnInit(): void {
    this.settingsService.logoLight$.subscribe((url) => (this.logoLight = url));
    this.settingsService.logoDark$.subscribe((url) => (this.logoDark = url));
  }

  toggleSidebar() {
    this.layoutService.closeSidebar = !this.layoutService.closeSidebar;
  }
}
